import { css } from '@emotion/react';

export const buttonCss =
  ({
    captions,
    disabled,
    fine,
    inversed,
    larger,
    pale,
    paleFine,
    pushRight,
    primary,
    readOnly,
    sharp,
    secondary,
    transparent,
    uppercase,
  }) =>
  (theme) =>
    [
      css`
        position: relative;
      `,
      captions &&
        css`
          text-transform: none;
          letter-spacing: normal;
        `,
      disabled &&
        css`
          opacity: 0.4 !important;
        `,
      fine &&
        css`
          background: none;
          border-color: currentColor;
        `,
      inversed &&
        css`
          color: ${theme.color.white};
          opacity: 0.7;
          &:active,
          &:focus,
          &:hover {
            color: ${theme.color.white} !important;
            opacity: 1;
          }
        `,
      larger &&
        css`
          height: 48px;
          line-height: 36px;
          padding-left: 24px;
          padding-right: 24px;
        `,
      pale &&
        css`
          background-color: ${theme.color.gray};
          border-color: ${theme.color.gray};
        `,
      paleFine &&
        css`
          background: none;
          border-color: ${theme.color.gray};
          color: ${theme.color.gray};
          &:active,
          &:focus,
          &:hover {
            background-color: ${theme.color.gray};
            border-color: ${theme.color.gray};
            color: ${theme.color.text};
          }
        `,
      pushRight &&
        css`
          margin-right: 8px;
        `,
      primary &&
        (fine
          ? css`
              border-color: ${theme.color.success};
              color: ${theme.color.success};
              .fa {
                color: ${theme.color.success};
              }
              &:active,
              &:focus,
              &:hover {
                background-color: ${theme.color.link};
                border-color: ${theme.color.link};
                color: ${theme.color.white};
                .fa {
                  color: ${theme.color.white};
                }
              }
            `
          : css`
              background-color: ${theme.color.success};
              border-color: ${theme.color.success};
              color: ${theme.color.white};
              &:active,
              &:focus,
              &:hover {
                background-color: ${theme.color.success} !important;
                border-color: ${theme.color.link};
                color: ${theme.color.white} !important;
              }
            `),
      readOnly &&
        css`
          pointer-events: none;
        `,
      sharp &&
        css`
          border: none;
        `,

      secondary &&
        (fine
          ? css`
              border-color: ${theme.color.brown};
              color: ${theme.color.brown};
              .fa {
                color: ${theme.color.brown};
              }
              &:active,
              &:focus,
              &:hover {
                background-color: ${theme.color.brown2};
                border-color: ${theme.color.brown2};
                color: ${theme.color.white};
                .fa {
                  color: ${theme.color.white};
                }
              }
            `
          : css`
              background-color: ${theme.color.brown};
              border-color: ${theme.color.brown};
              color: ${theme.color.white};
              &:active,
              &:focus,
              &:hover {
                background-color: ${theme.color.brown2};
                border-color: ${theme.color.brown2};
                color: ${theme.color.white};
              }
            `),
      transparent &&
        css`
          background: none !important;
          border: 0;
        `,
      uppercase &&
        css`
          text-transform: uppercase;
        `,
    ];

export const labelCss = (showPreloader) =>
  showPreloader &&
  css`
    visibility: hidden;
  `;
export const preloaderCss = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
